import React from 'react';
import { Field, Pill, inputCls, slug } from './atoms';
import { PRIORITIES, MEXICO_VISITS } from './constants';

const Step6Lifestyle = ({ form, errors, upd, setField, togglePriority }) => (
  <div data-testid="step-6">
    <div className="mb-5">
      <h1 className="text-xl sm:text-2xl font-light" data-testid="step6-headline">What matters most?</h1>
      <p className="text-sm mt-1 text-[#5A6B73]">Pick up to 3 priorities - they shape the whole plan.</p>
    </div>

    <div className="space-y-4">
      <Field
        label={`Priorities (pick up to 3 - ${form.priorities.length}/3)`}
        error={errors.priorities}
        testId="field-priorities"
      >
        <div className="grid grid-cols-2 gap-2">
          {PRIORITIES.map((p) => {
            const active = form.priorities.includes(p);
            const disabled = !active && form.priorities.length >= 3;
            return (
              <button
                key={p}
                type="button"
                onClick={() => !disabled && togglePriority(p)}
                aria-pressed={active}
                disabled={disabled}
                data-testid={`onboarding-priority-${slug(p)}`}
                className={`text-left px-3 py-2 text-xs rounded-lg border transition-all font-body ${
                  active
                    ? 'border-[#E8A830] bg-[#E8A830]/10 text-[#0A1F2E] font-medium'
                    : disabled
                    ? 'border-[#EFE6CF] text-[#0A1F2E]/30 bg-white cursor-not-allowed'
                    : 'border-[#EFE6CF] text-[#0A1F2E]/75 hover:border-[#2CA8A0]/50 bg-white'
                }`}
              >
                {p}
              </button>
            );
          })}
        </div>
      </Field>

      <Field label="Have you visited Mexico before?" optional testId="field-mexico-visits">
        <div className="grid grid-cols-2 gap-2">
          {MEXICO_VISITS.map((m) => (
            <Pill key={m} small active={form.mexico_visits === m}
              onClick={() => setField('mexico_visits', m)}
              testId={`onboarding-visits-${slug(m)}`}>
              {m}
            </Pill>
          ))}
        </div>
      </Field>

      <Field label="How did you hear about Mundalo?" optional testId="field-referral">
        <input type="text" value={form.referral_source} onChange={upd('referral_source')}
          placeholder="e.g. friend, podcast, Instagram…"
          className={inputCls(false)} data-testid="onboarding-referral" />
      </Field>
    </div>
  </div>
);

export default Step6Lifestyle;
